import { storeModel } from './store-models'
import { createStore } from "easy-peasy"

const store = createStore(storeModel);
export default store;